import Swiper from 'swiper/bundle';

export default () => {
    const timelines = document.querySelectorAll('.js-Timeline');

  if (timelines) {
    timelines.forEach(timeline => {
      const swiper = timeline.querySelector('.js-swiperTimeline');
      const slides = timeline.querySelectorAll('.swiper-slide');
      new Swiper(swiper, {
        slidersPerView: 1,
        effect: 'fade',
        autoplay: {
          delay: 5000,
        },
        fadeEffect: {
          crossFade: true,
          transformEl: '.TimelineSlide',
        },
        navigation: {
          nextEl: swiper.querySelector('.swiper-button-next'),
          prevEl: swiper.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: timeline.querySelector('.js-swiper-timeline-pagination'), 
          dynamicBullets: true,
          clickable: true,
          renderBullet: function (index, className) {
            return `<div class="Timeline__PaginationItem Swiper__PaginationItem ${className}">
              <span class="Timeline__PaginationItemLabel Swiper__PaginationItemLabel">${slides[index].dataset.bulletName}</span>
            </div>`;
          },
        },
      });
    });
  }

    
}